export const isAuthenticated = (state) => {
    // Check for both new (accessToken) and old (idToken) structures for compatibility
    if (state.auth.auth.accessToken || state.auth.auth.idToken) return true;
    return false;
};
